import styled from 'styled-components';

type AlignTextProps = {
  to: 'center' | 'left'
}

export const AlignText = styled.div<AlignTextProps>`
  text-align: ${props => props.to === 'center' ? 'center' : 'left'};
`;

AlignText.defaultProps = {
  to: 'center',
};
